import { Koi } from '@ksyos/koi';
import type { ISchemaContainer } from './schemaContainer';
import type { GroupChoice, OrganizationChoice, ServiceChoice } from './schemas/choiceSchema';
import {
    FilterChoice,
    filterChoiceSchema,
    groupChoiceSchema,
    organizationChoiceSchema,
    serviceChoiceSchema,
} from './schemas/choiceSchema';

export interface IInvoiceRecordsExportValidated {
    batchId: string | null;
    closedBeforeDate: string | null;
    episodeCategory: string | null;
    filterChoice: FilterChoice;
    groupChoice: GroupChoice;
    groupId: string | null;
    isPreview?: boolean;
    organizationChoice: OrganizationChoice;
    organizationName: string | null;
    serviceChoice: ServiceChoice;
    serviceId: string | null;
}

export const invoiceRecordsExportSchema: ISchemaContainer<IInvoiceRecordsExportValidated> = {
    schema: Koi.object({
        batchId: Koi.string().uuid().allow(null),
        closedBeforeDate: Koi.when('batchId', {
            is: null,
            otherwise: Koi.koi().date().allow(null),
            then: Koi.koi().date(),
        }),
        episodeCategoryId: Koi.when('filterChoice', {
            is: FilterChoice.compositePatientInvoice,
            otherwise: Koi.string().uuid().allow(null),
            then: Koi.string().uuid(),
        }),
        filterChoice: Koi.when('batchId', {
            is: null,
            otherwise: filterChoiceSchema.allow(null),
            then: filterChoiceSchema,
        }),
        groupChoice: groupChoiceSchema,
        groupId: Koi.when('groupChoice', {
            is: 'specific',
            otherwise: Koi.string().uuid().allow(null),
            then: Koi.string().uuid(),
        }),
        isPreview: Koi.boolean(),
        organizationChoice: organizationChoiceSchema,
        organizationName: Koi.when('organizationChoice', {
            is: 'specific',
            otherwise: Koi.string().allow(null),
            then: Koi.string().max(255),
        }),
        serviceChoice: serviceChoiceSchema,
        serviceId: Koi.when('serviceChoice', {
            is: 'specific',
            otherwise: Koi.string().uuid().allow(null),
            then: Koi.string().uuid(),
        }),
    }).options({ convert: false, presence: 'required' }),
};
